import clsx from 'clsx'
import { FC } from 'react'
import Image from 'next/image'
import PdImage from '@/components/pd-image/pd-image'
import PdMedia from '@/components/pd-media/pd-media'

const TagItemRightIcon: FC<{
  title?: string
  desc?: string
  icon?: string
  containerClassName?: string
  titleClassName?: string
  descClassName?: string
  fontColor?: string
}> = ({ title, desc, icon, containerClassName, titleClassName, descClassName, fontColor }) => {
  return (
    <div className={clsx('flex flex-col gap-1', 'laptop:gap-1', containerClassName)}>
      <div className={clsx('flex laptop:justify-center')}>
        {title && (
          <h2
            className={clsx('font-bold', 'text-fc-primary pd-first-title laptop:leading-[56px]', titleClassName)}
            style={{ color: fontColor }}
          >
            {title}
          </h2>
        )}
        {icon && (
          <div className="w-8 laptop:w-12 relative ml-1 laptop:ml-2">
            <PdMedia src={icon} alt="" object="contain" mask={false} />
          </div>
        )}
      </div>
      <p className={clsx('text-fc-secondary pd-main-text laptop:text-center', descClassName)}>{desc}</p>
    </div>
  )
}

export default TagItemRightIcon
